<template>
  <div>
    <!-- <span>测试供货商商品</span> -->
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <div v-for="tab in tabs" :key="tab.key" class="text-sm tab cursor-pointer text-sm"
          :class="{ 'active': curTab == tab.key }" @click="curTab = tab.key">
          {{ tab.name }}
          <span class="text-xs">({{ tab.num }})</span>
        </div>
        <el-button type="primary" size="small" class="ml-4 mr-4" @click="showSelect = true">
          +{{ $t('新增商品') }}
        </el-button>
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ $t('批量操作') }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command='on'>{{ $t('批量上架') }}</el-dropdown-item>
            <el-dropdown-item command='off'>{{ $t('批量下架') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
      <div>
        <Search :placeholder="$t('商品名称/关键词')" @search="search"></Search>
      </div>
    </div>
    <div>
      <div class="layout titles">
        <div v-for="(title, index) in titles" :key="index">{{ title }}</div>
      </div>
      <div class="all-select">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      </div>
      <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
      <div class="layout product" v-for="item in products" :key="item.id">
          
          <!-- <div><el-checkbox label="复选框 A"></el-checkbox></div> -->
          
          <div class="img-box">
            <el-checkbox :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
            <img :src="$firstImage(item.images, 'small')" class="img">
            <!-- <span class="text-base">{{ item.name }}</span> -->
            <span class="text-base"></span>
            <span class="text-sm text-gray-400">{{ item.attribute_text }}</span>

          </div>
          <div class="text-sm">
            <span>{{ $p(item.price) }}</span>
            <span style="color: #407CFF;" class="cursor-pointer"
              @click="curProduct = item, curType = 'price', showModify = true">{{ $t('修改价格') }}</span>
          </div>

          <div class="text-sm">
            <span>{{ item.stock }}</span>
            <span style="color: #407CFF;" class="cursor-pointer"
              @click="curProduct = item, curType = 'stock', showModify = true">{{
                $t('修改库存') }}</span>
          </div>
          <div class="text-sm">
            {{ item.sales }}
          </div>
          <div class="text-sm space-y-1 cursor-pointer ">
            <span style="color: #407CFF;" @click="curPid = item.id, showEdit = true, isCopy=true">{{ $t('复制商品') }}</span>
            <span style="color: #407CFF;" @click="curPid = item.id, showEdit = true, isCopy=false">{{ $t('编辑') }}</span>
            <span style="color: #407CFF;" @click="doShelves(item)">{{ item.status == 0 ? $t('上架') : (item.status == 10 ?
              $t('下架') : '') }}</span>
            <span style="color:#FF4747" @click="delProduct(item.id)">{{ $t('删除') }}</span>

          </div>
        
      </div>
      </el-checkbox-group>
      <el-pagination background layout="prev, pager, next" :total="pager.total" :page-size="pager.size"
        @current-change="pageChange" v-if="pager.total" class="mt-6">
      </el-pagination>
    </div>
    <div v-if="!pager.total" class="mt-60">
      <img :src="require(`@/assets/image/暂无收藏.png`)" class="mx-auto" />
    </div>
    <el-dialog :title="curType == 'price' ? $t('改价') : $t('改库存')" :visible.sync="showModify" width="32rem" top="20vh">
      <div v-if="curProduct && curType == 'price'" class="info">
        <div class="img-box">
          <img :src="$firstImage(curProduct.images, 'small')">
          <span class="text-lg">{{ curProduct.name }}</span>
          <span><span class="text-gray-400">{{ $t('当前价格') }}</span>{{ $p(curProduct.price) }}</span>
        </div>
        <div class="flex-center px-10 py-11">

          <span class="whitespace-nowrap pr-4"> {{ $t('改后价格') }}</span>
          <el-input placeholder="请输入内容" v-model="curProduct.curPrice">
            <template slot="append">{{ $t('元') }}</template>
          </el-input>
        </div>

      </div>
      <div v-else-if="curProduct && curType == 'stock'" class="info">
        <div class="img-box">
          <img :src="$firstImage(curProduct.images, 'small')">
          <span class="text-lg">{{ curProduct.name }}</span>
          <span><span class="text-gray-400">{{ $t('当前库存') }} </span>{{ curProduct.stock }}</span>
        </div>
        <div class="flex-center px-10 py-11">
          <span class="whitespace-nowrap pr-4"> {{ $t('改后库存') }}</span>
          <el-input placeholder="请输入内容" v-model="curProduct.curStock">
          </el-input>
        </div>

      </div>
      <div class="space-x-4">
        <el-button class="w-12rem" @click="showModify = false, curProduct = null">{{ $t('取消') }}</el-button>
        <el-button type="primary" class="w-12rem" @click="editProduct">{{ $t('确定') }}</el-button>
      </div>
    </el-dialog>
    <goodslist :show="showSelect" @close="showSelect = false" @getCurPProduct="getCurPProduct"></goodslist>
    <productedit :show="showEdit" @close="showEdit = false" :product="product" :pid="curPid" :isCopy="isCopy" @reload="loadData"></productedit>
  </div>
</template>
<script>
import Search from "@/components/mine/search.vue";
import goodslist from "@/components/supplier/goodslist.vue"
import productedit from "@/components/supplier/productedit.vue"
import {
  ref,
  computed,
  watchEffect
} from "@vue/composition-api";

export default {
  components: { Search, goodslist, productedit },
  setup(props, ctx) {
    const count = ref()
    let checkList = ref([])
    let cityOptions = ref([])
    let checkAll = ref(false)
    let cities = cityOptions
    let isIndeterminate = ref(false)
    const getCount = async () => {
      let res = await ctx.root.$callapi('sup/getProductCount')
      if (res.code == 0 && res.data) {
        count.value = res.data
      }
    }
    getCount()
    const curTab = ref('on')
    const tabs = computed(() => {
      return [{
        key: 'on',
        name: ctx.root.$t('在售中'),
        num: count?.value?.on_count
      },
      {
        key: 'sellout',
        name: ctx.root.$t('已售罄'),
        num: count?.value?.sold_out_count
      },
      {
        key: 'off',
        name: ctx.root.$t('下架商品'),
        num: count?.value?.off_count
      }
      ]
    })
    const titles = [
      ctx.root.$t('商品'),
      ctx.root.$t('当前价格'),
      ctx.root.$t('库存'),
      ctx.root.$t('已售'),
      ctx.root.$t('操作')
    ]
    let products = ref()
    const keyword = ref()
    const onPager = new ctx.root.$Pager({
      apiname: 'sup/getOnShelvesProducts',
      param: () => ({
        tag: 'product',
        q__name__contains:keyword.value

      }),
      size: 10,
      onLoaded: (res) => {
        if (res.code == 0 && res.data) {
          // products.value = res.data.items
          let product_items = res.data.items
          products.value = product_items
          let items_length = product_items.length
          console.log("items_length:", items_length)
          // console.log("")
          for(let i=0; i<items_length; i++){
            cityOptions.value.push(product_items[i].id)
            // console.log("i:",i)
          }
        }
      }

    })
    const offPager = new ctx.root.$Pager({
      apiname: 'sup/getOffShelvesProducts',
      param: () => ({
        tag: 'product',
        q__name__contains:keyword.value

      }),
      onLoaded: (res) => {
        if (res.code == 0 && res.data) {
          let product_items = res.data.items
          products.value = product_items
          let items_length = product_items.length
          for(let i=0; i<items_length; i++){
            // cityOptions.push(product_items[i].id)
            cityOptions.value.push(product_items[i].id)
          }
        }
      }
    })
    const selloutPager = new ctx.root.$Pager({
      apiname: 'sup/getOnShelvesProducts',
      param: () => ({
        tag: 'product',
        q__stock__lte: 0,
        q__name__contains:keyword.value

      }),
      onLoaded: (res) => {
        if (res.code == 0 && res.data) {
          let product_items = res.data.items
          products.value = product_items
          let items_length = product_items.length
          for(let i=0; i<items_length; i++){
            // cityOptions.push(product_items[i].id)
            cityOptions.value.push(product_items[i].id)
          }
        }
      }
    })

    const pager = computed(() => {
      let obj = null
      switch (curTab.value) {
        case 'sellout':
          obj = selloutPager
          break;
        case 'on':
          obj = onPager
          break;
        case 'off':
          obj = offPager
          break;
      }
      console.log(obj);
      return obj
    })
    watchEffect(async () => {
      await pager.value.first()
    })

    const showModify = ref(false)
    const curProduct = ref(null)
    const curType = ref('price')
    //  上下架商品
    const doShelves = async (item) => {
      console.log(pager.value);

      let action = null
      let text = null
      switch (item.status) {
        case 0:
          action = 'on'
          text = ctx.root.$t('您需要上架此商品?')
          break;
        case 10:
          action = 'off'
          text = ctx.root.$t('您正在下架该商品?')
          break;
      }
      let query = await ctx.root.$query(text)
      if (!query) return
      let res = await ctx.root.$callapi('sup/doShelves', {
        action: action,
        pid: item.id
      })
      if (res.code == 0 && res.data) {
        ctx.root.$toast(ctx.root.$t('操作成功'), 'success')
        if (!pager.value.hasNext && pager.value.hasPrev && pager.value.items?.length == 1) {
          await pager.value.load(pager.value.page - 1)
        } else {
          await pager.value.load(pager.value.page)
        }
        await getCount()
      }
    }

    const batchShelves = async (action) => {
      console.log('action:', action);
      console.log('checkList', checkList.value)
      console.log('checkAll', checkAll.value)
      let text = null
      if (action=="on"){
        text = ctx.root.$t("你确定要把已选中的商品批量上架吗?")
      }else{
        text = ctx.root.$t("你确定要把已选中的商品批量下架吗?")
      }

      let query = await ctx.root.$query(text)
      if (!query) return
      ctx.root.$doing()
      let res = await ctx.root.$callapi('sup/doBatchShelves', {'pids': checkList.value, 'action': action, 'is_all': checkAll.value})
      ctx.root.$done()
      if (res.code == 0 && res.data) {
        ctx.root.$toast(ctx.root.$t('操作成功'), 'success')
        if (!pager.value.hasNext && pager.value.hasPrev && pager.value.items?.length == 1) {
          await pager.value.load(pager.value.page - 1)
        } else {
          await pager.value.load(pager.value.page)
        }
        await getCount()
      }
      checkList.value = []
      checkAll.value = false
    }

    const handleCommand = (command)=>{
      console.log("111")
      batchShelves(command)
    }

    const editProduct = async () => {
      let { id, stock, price, curPrice, curStock } = curProduct.value
      let param = {
        pid: id
      }
      if (curType.value == 'price') {
        if (!curPrice) {
          return ctx.root.$toast(ctx.root.$t('请输入价格'))
        }

        param.stock = stock
        param.price = parseFloat(curPrice)
      } else if (curType.value == 'stock') {
        if (!curStock) {
          return ctx.root.$toast(ctx.root.$t('请输入库存'))
        }
        param.price = price
        param.stock = parseFloat(curStock)
      }
      // return
      // console.log(this.curProduct);
      ctx.root.$doing()
      let res = await ctx.root.$callapi('sup/addOrUpdateProduct', param)
      ctx.root.$done()
      if (res.code == 0 && res.data) {
        curProduct.value = null
        showModify.value = false
        await pager.value.load(pager.value.page)
        await ctx.root.$toast(ctx.root.$t('操作成功'), 'success')
        await getCount()
      }
    }
    const delProduct = async (id) => {
      console.log(pager.value);
      let query = await ctx.root.$query(ctx.root.$t('您确定需要删除此商品?'))
      if (!query) return
      let res = await ctx.root.$callapi('sup/deleteProduct', {
        pid: id
      })
      if (res.code == 0 && res.data) {
        ctx.root.$toast(ctx.root.$t('删除成功'), 'success')
        if (!pager.value.hasNext && pager.value.hasPrev && pager.value.items?.length == 1) {
          await pager.value.load(pager.value.page - 1)
        } else {
          await pager.value.load(pager.value.page)
        }
      }
      await getCount()

    }
    const showSelect = ref(false)
    const showEdit = ref(false)
    const curPid = ref(null)
    const isCopy = ref(false)
    const pageChange = async (page) => {
      await pager.value.load(page)
    }
    const product = ref({})
    const getCurPProduct = (item) => {
      showEdit.value = true
      product.value = JSON.parse(item)
    }
    const loadData = async () => {
      getCount()
      if (!pager.value.hasNext && pager.value.hasPrev && pager.value.items?.length == 1) {
        await pager.value.load(pager.value.page - 1)
      } else {
        await pager.value.load(pager.value.page)
      }
    }
    const search = async(val) =>{
      keyword.value = val
      await pager.value.first()
    }

    const handleCheckAllChange = (val) => {
      console.log("val:", val)
      console.log("val-checkList:", checkList)
      console.log("val-cityOptions:", cityOptions)
      checkList.value = val ? cityOptions.value : [];
      isIndeterminate.value = false;
    }

    const handleCheckedCitiesChange = (value) => {
      // console.log(1111)
      console.log("value:", value)
      console.log("value-checkList:", checkList)
      let checkedCount = ref(value.length);
      // console.log(2222)
      checkAll.value = checkedCount.value === cities.value.length;
      // console.log(3333)
      isIndeterminate.value = checkedCount.value > 0 && checkedCount.value < cities.value.length;
      // console.log(4444)
    }
    return {
      tabs, titles, products, curTab,
      pager, pageChange, showModify, curProduct, curType,
      doShelves, editProduct, delProduct, showSelect, showEdit, getCurPProduct, product, curPid, loadData,
      search, checkList, batchShelves, handleCommand, checkAll, cities, isIndeterminate, handleCheckAllChange, handleCheckedCitiesChange,
      isCopy
    };
  },
};
</script>
<style scoped lang="scss">
.tab {
  height: 2.063rem;
  padding: 0 0.875rem;
  border: 0.063rem solid #e0e0e0;
  line-height: 2.063rem;

  &.active {
    border-color: #34B66B;
  }
}

.layout {
  display: grid;
  grid-template-columns: 35% 18% 16% 14% auto;


}

.titles {
  background-color: #F4F4F5;
  height: 2rem;
  align-items: center;
  margin-top: 1.063rem;
  @apply text-sm;
}

.product {
  border: 0.063rem solid #e4e4e4;
  margin-top: 0.625rem;

  &>div {
    &:not(:first-child) {
      @apply flex flex-col justify-center;
      border-left: 0.063rem solid #e4e4e4;
    }
  }

  .img-box {
    display: grid;
    grid-template-columns: 13rem 4.5rem auto;
    grid-column-gap: 0.563rem;
    text-align: left;
    padding: 0.688rem 0 0.813rem 0.938rem;
    align-items: center;

    .img {
      width: 4.5rem;
      height: 4.5rem;
      grid-row: 1/3;
      grid-column: 2/3;
    }
  }
}

.info {
  display: grid;
  padding: 0 1.5rem;

  .img-box {
    display: grid;
    grid-template-columns: 3.75rem auto;
    // justify-content: flex-start;
    // align-items: center;
    text-align: left;
    grid-column-gap: 0.938rem;

    img {
      width: 3.75rem;
      height: 3.75rem;
      border-radius: 0.375rem;
      grid-row: 1/3;
    }
  }

}

.all-select {
  width: 4rem;
}
</style>
